import { WithChildren } from '@/types'
import { createContext } from '@/ultils'
import { HubConnection, HubConnectionState } from '@microsoft/signalr'
import { useCallback, useEffect, useMemo, useState } from 'react'
import RealtimeHubService from '.'

interface State {
}

interface SignalRContextValues extends State {
  getHubConnect: () => Promise<HubConnection>
}

const [Provider, useSignalR] = createContext<SignalRContextValues>({
  name: 'SignalR',
})

const SignalRProvider = ({ children }: WithChildren) => {
  const [connection, setConnection] = useState<HubConnection>()

  const getHubConnect = useCallback(async () => {
    let _connection = connection
    if (!_connection) {
      _connection = new RealtimeHubService().getHubConnect()
    }

    if (_connection.state === HubConnectionState.Disconnected) {
      await _connection.start()
    }

    setConnection(_connection)
    return _connection
  }, [connection])

  useEffect(() => {
    const connection = new RealtimeHubService().getHubConnect()
    setConnection(connection)
    return () => {
      connection.stop()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const value = useMemo(() => {
    return {
      getHubConnect,
    }
  }, [getHubConnect])

  return <Provider value={value}>{children}</Provider>
}

export { SignalRProvider, useSignalR }